import * as React from 'react';
import './collapseIcon.scss';

export interface ICollapseIconProps {
    classIconCategory?: string;
    classIconClose?: string;
    classIconOpen?: string;
    className?: string;
    headline: string;
    onChange?: (currentState: boolean) => void;
    startOpen?: boolean;
}

export interface ICollapseIconState {
    isOpen: boolean;
}

export default class CollapseIcon extends React.Component<ICollapseIconProps, ICollapseIconState> {
    constructor(props: ICollapseIconProps) {
        super(props);
        this.handleToggle = this.handleToggle.bind(this);
        this.state = {
            isOpen: !!this.props.startOpen
        };
    }

    render(): React.ReactNode {
        const { headline } = this.props;
        const className = this.props.className || '';
        const classIconCategory = this.props.classIconCategory || 'icon-sliders';
        const classIconClose = this.props.classIconClose || 'icon-right-open';
        const classIconOpen = this.props.classIconOpen || 'icon-down-open';
        const classIconCurrentStatus = this.state.isOpen ? classIconOpen : classIconClose;

        return (
            <div className={`collapse-icon ${this.state.isOpen ? 'collapse-icon--is-open' : ''} ${className}`}>
                <button onClick={this.handleToggle} className="collapse-icon__header pxl-link">
                    <i className={`collapse-icon__icon-category ${classIconCategory}`} />
                    <span className="collapse-icon__name">{headline}</span>
                    <i className={`collapse-icon__icon-toggle ${classIconCurrentStatus}`} />
                </button>
                <div className="collapse-icon__body">
                    {this.props.children}
                </div>
            </div>
        );
    }

    private handleToggle(): void {
        const newStatus = !this.state.isOpen;
        if (this.props.onChange) {
            this.props.onChange(newStatus);
        }
        this.setState({
            isOpen: newStatus
        });
    }
}